import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=c38f26c8"
import script from "./MainView.ts?vue&type=script&lang=ts&external"
export * from "./MainView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports